import { createSlice } from "@reduxjs/toolkit";
import JSEncrypt from "jsencrypt";
import { EsubeApi, MainApi } from "../services/authentication/api";
import { Configuration } from "../services/authentication/configuration";

const encrypt = new JSEncrypt();
encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOJu6TyygqxfWT7eLtGDwajtN
FOb9I5XRb6khyfD1Yt3YiCgQWMNW649887VGJiGr/L5i2osbl8C9+WJTeucF+S76
xFxdU6jE0NQ+Z+zEdhUTooNRaY5nZiu5PgDB0ED/ZKBUSLKL7eibMxZtMlUDHjm4
gwQco1KRMDSmXSMkDwIDAQAB
-----END PUBLIC KEY-----`);
const decrypt = new JSEncrypt();
decrypt.setPrivateKey(`-----BEGIN RSA PRIVATE KEY-----
MIICXQIBAAKBgQDlOJu6TyygqxfWT7eLtGDwajtNFOb9I5XRb6khyfD1Yt3YiCgQ
WMNW649887VGJiGr/L5i2osbl8C9+WJTeucF+S76xFxdU6jE0NQ+Z+zEdhUTooNR
aY5nZiu5PgDB0ED/ZKBUSLKL7eibMxZtMlUDHjm4gwQco1KRMDSmXSMkDwIDAQAB
AoGAfY9LpnuWK5Bs50UVep5c93SJdUi82u7yMx4iHFMc/Z2hfenfYEzu+57fI4fv
xTQ//5DbzRR/XKb8ulNv6+CHyPF31xk7YOBfkGI8qjLoq06V+FyBfDSwL8KbLyeH
m7KUZnLNQbk8yGLzB3iYKkRHlmUanQGaNMIJziWOkN+N9dECQQD0ONYRNZeuM8zd
8XJTSdcIX4a3gy3GGCJxOzv16XHxD03GW6UNLmfPwenKu+cdrQeaqEixrCejXdAF
z/7+BSMpAkEA8EaSOeP5Xr3ZrbiKzi6TGMwHMvC7HdJxaBJbVRfApFrE0/mPwmP5
rN7QwjrMY+0+AbXcm8mRQyQ1+IGEembsdwJBAN6az8Rv7QnD/YBvi52POIlRSSIM
V7SwWvSK4WSMnGb1ZBbhgdg57DXaspcwHsFV7hByQ5BvMtIduHcT14ECfcECQATe
aTgjFnqE/lQ22Rk0eGaYO80cc643BXVGafNfd9fcvwBMnk0iGX0XRsOozVt5Azil
psLBYuApa66NcVHJpCECQQDTjI2AQhFc1yRnCU/YgDnSpJVm1nASoRUnU8Jfm3Oz
uku7JUXcVpt08DFSceCEX9unCuMcT72rAQlLpdZir876
-----END RSA PRIVATE KEY-----`);

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || false,
  email: JSON.parse(localStorage.getItem("email"))
    ? decrypt.decrypt(JSON.parse(localStorage.getItem("email")))
    : "",
  password: JSON.parse(localStorage.getItem("password"))
    ? decrypt.decrypt(JSON.parse(localStorage.getItem("password")))
    : "",
  rememberMe: JSON.parse(localStorage.getItem("rememberMe")) || false,
  rememberMeUserLogin: JSON.parse(localStorage.getItem("rememberMeUserLogin")) || {
    customerNumber: "",
    password: ""
  },
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
  accountId: localStorage.getItem("accountId") ? localStorage.getItem("accountId") : "",
  mfaTraceId: localStorage.getItem("mfaTraceId") || "",
};

const LOGOUT_PRESERVED_KEYS = new Set(["email", "password", "rememberMe", "rememberMeUserLogin"]);

const emptyRememberMeUserLogin = {
  customerNumber: "",
  password: ""
};

const clearRememberedCredentials = () => {
  localStorage.removeItem("email");
  localStorage.removeItem("password");
  localStorage.removeItem("rememberMeUserLogin");
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.user = action.payload;

      localStorage.setItem("user", JSON.stringify(action.payload.user));

      state.token = action.payload.token;
      state.accountId = action.payload.accountId;
      state.expireDate = action.payload.expireDate;
      state.mfaTraceId = action.payload.mfaTraceId || "";

      localStorage.setItem("token", state.token);
      localStorage.setItem("accountId", state.accountId);
      localStorage.setItem("expireDate", state.expireDate);
      localStorage.setItem("mfaTraceId", state.mfaTraceId);

      if (state.rememberMe) {
        localStorage.setItem(
          "email",
          JSON.stringify(encrypt.encrypt(action.payload.mail))
        );
        localStorage.setItem(
          "password",
          JSON.stringify(encrypt.encrypt(action.payload.password))
        );
      }
    },
    logout(state) {
      state.user = false;
      state.token = "";
      state.accountId = "";
      state.expireDate = "";
      state.mfaTraceId = "";

      Object.keys(localStorage).forEach((key) => {
        if (!LOGOUT_PRESERVED_KEYS.has(key)) {
          localStorage.removeItem(key);
        }
      });
    },
    setRememberMe(state, action) {
      state.rememberMe = Boolean(action.payload);
      localStorage.setItem("rememberMe", JSON.stringify(action.payload));

      if (!state.rememberMe) {
        state.email = "";
        state.password = "";
        state.rememberMeUserLogin = emptyRememberMeUserLogin;
        clearRememberedCredentials();
      }
    },
    setFavoritesSecuritiesData(state, action) {
      state.favoritesSecuritiesData = action.payload;
      localStorage.setItem("favoritesSecuritiesData", JSON.stringify(action.payload));
    },
    setRememberMeUserLogin(state, action) {
      state.rememberMeUserLogin = action.payload || emptyRememberMeUserLogin;

      if (action.payload) {
        localStorage.setItem("rememberMeUserLogin", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("rememberMeUserLogin");
      }
    }
  },
});

export const { login, logout, setRememberMe, setFavoritesSecuritiesData, setRememberMeUserLogin } = auth.actions;

export const performLogout = () => async (dispatch, getState) => {
  const { mfaTraceId, token } = getState().auth;

  try {
    const authConfig = new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH });

    // mfaTraceId sadece e-şube (Kullanıcı Girişi) oturumlarında dolu olur; üye girişinde (MainApi) IdentityToken kullanılır.
    if (mfaTraceId) {
      const esubeApi = new EsubeApi(authConfig);
      await esubeApi.apiEsubeLogoutPost(mfaTraceId);
    } else {
      const mainApi = new MainApi(authConfig);
      await mainApi.apiMainSignOutPost({ IdentityToken: token });
    }
  } catch (error) {
    console.error("logout error:", error);
  } finally {
    dispatch(logout());
  }
};

export default auth.reducer;
